const DayEnToFr = (day: string) => {
  const dayFr = ['Samedi', 'Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi'];
  const dayEn = ['saturday', 'sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
  let dayLowCase = day.toLowerCase();
  for (let i = 0; i < dayEn.length; i++) {
    if (dayEn[i] === dayLowCase) {
      return (dayFr[i]);
    }
  }
  return (day);
};

export default DayEnToFr;
export const weekDay = ['saturday', 'sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday'];